import KzsApi from './kzs.api';

class KzsService {
  constructor() {
    this.api = new KzsApi();
  }

  /**
   *  Метод для получения списка нозологий
   * @param {Object} params - Параметры запроса
   * @param {string} params.nosologyName - Строка поиска
   * @param {number} params.page - Номер страницы
   * @param {number} params.limit - Количество нозологий на странице
   * @returns
   */
  async getKzsList(params) {
    return await this.api.getKzsList(params);
  }

  /**
   *  Метод для получения КЗС
   * @param {string} id - ID КЗС
   * @returns
   */
  async getKzs(id) {
    return await this.api.getKzs(id);
  }

  /**
   *  Метод для удаления кзс
   * @param {string} id - ID кзс
   * @returns
   */
  async deleteKzs(id) {
    return await this.api.deleteKzs(id);
  }

  /**
   *  Метод для создания КЗС
   * @param {Object} params - Параметры запроса
   * @param {string} params.type - Тип КЗС
   * @param {string} params.algorithm - Алгоритм
   * @param {string} params.nosologyId - ID нозологии
   * @param {string} params.assignmentTemplateId - ID шаблона задачи
   * @param {string} params.name - Наименование КЗС
   * @param {string} params.description - Описание КЗС
   * @returns
   */
  async createKzs(params) {
    return await this.api.createKzs(params);
  }

  /**
   *  Метод для получения списка доступных алгоритмов
   * @param {Object} params - Параметры запроса
   * @param {string} params.kzsType - тип КЗС, выбранный пользователем
   * @param {string} params.kzsSubType - зависит от настройки "Участвует в формировании КЗС"(subType), проставленной пользователем в первом шаге формы
   * @returns
   */
  async getAvailableAlgorithms(params) {
    return await this.api.getAvailableAlgorithms(params);
  }

}

const kzsService = new KzsService();
export default kzsService
